import React from "react";

interface ScheduleSkeletonProps {
  isDarkMode?: boolean;
}

export default function ScheduleSkeleton({ isDarkMode = false }: ScheduleSkeletonProps) {
  const bgMain = isDarkMode ? "bg-gray-900" : "bg-white";
  const borderCol = isDarkMode ? "border-gray-700" : "border-gray-200";
  const skeletonBg = isDarkMode ? "bg-gray-800" : "bg-gray-200";
  const skeletonBgSoft = isDarkMode ? "bg-gray-700" : "bg-gray-100";

  return (
    <div className={`flex-1 flex flex-col h-screen transition-colors duration-300 ${bgMain}`}>
      {/* Header */}
      <div
        className={`border-b p-6 transition-colors duration-300 ${borderCol}`}
      >
        <div className="flex items-center justify-between">
          {/* Left side - Filter and Add buttons */}
          <div className="flex items-center gap-2">
            <div className={`h-9 w-9 rounded ${skeletonBg}`} />
            <div className={`h-9 w-20 rounded ${skeletonBg}`} />
          </div>

          {/* Center - View title */}
          <div className={`h-6 w-64 rounded ${skeletonBg}`} />

          {/* Right side - View options */}
          <div className="flex items-center gap-2">
            <div className={`h-9 w-20 rounded ${skeletonBg}`} />
            <div className={`h-9 w-20 rounded ${skeletonBg}`} />
            <div className={`h-9 w-9 rounded ${skeletonBg}`} />
          </div>
        </div>
      </div>

      {/* Main calendar grid area */}
      <div className="flex-1 flex flex-col max-h-screen overflow-hidden">
        <div className="flex-1 p-6 overflow-auto animate-pulse">
          {/* Day headers */}
          <div className="grid grid-cols-7 gap-1 mb-2">
            {Array.from({ length: 7 }).map((_, i) => (
              <div
                key={`header-${i}`}
                className={`h-8 rounded ${skeletonBgSoft}`}
              />
            ))}
          </div>

          {/* Calendar cells grid - 5 weeks x 7 days = 35 cells */}
          <div className="grid grid-cols-7 gap-1">
            {Array.from({ length: 35 }).map((_, i) => (
              <div
                key={`cell-${i}`}
                className={`min-h-32 p-3 rounded border transition-colors duration-300 ${
                  isDarkMode ? "bg-gray-800 border-gray-700" : "bg-gray-50 border-gray-200"
                }`}
              >
                {/* Date number skeleton */}
                <div className={`h-4 w-6 rounded mb-2 ${skeletonBg}`} />

                {/* Event placeholders */}
                <div className="space-y-2">
                  <div className={`h-3 w-full rounded ${skeletonBgSoft}`} />
                  <div className={`h-3 w-4/5 rounded ${skeletonBgSoft}`} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
